export default "__VITE_ASSET__D1350lV$__"